import {
  Box,
  SimpleGrid,
  Text,
  Flex,
  VStack,
  Center,
  useToast,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
} from "@chakra-ui/react";
import { Formik, Field } from 'formik';
import LineSection from "../lineSection";
import Lang from "../../Lang";

export default function Formulary() {
  const toast = useToast()
  const SeccessNotificacion = 'The message has been sent successfully!';

  return (
    <Box
      color={"white"}
    >
      <Box
        display={{ base: "none", md: "inline" }}
      >
        <LineSection />
      </Box>
      <SimpleGrid columns={{ base: 1, md: 1, xl: 2 }}>

        {/* left section */}
        <Box
          bgImage={"img/laptop-notebook-microphone-table-meeting-room-seminar-room-with-copy-s.webp"}
          backgroundSize={"cover"}
          backgroundPosition={"center"}
          display={{ base: "none", md: "none", xl: "inline" }}
        >
          <Box className="opacityTop"
            h={"50%"}
          >
            &nbsp;
          </Box>
          <Box className="opacityBottom"
            h={"50%"}
          >
            &nbsp;
          </Box>
        </Box>

        {/* right section */}
        <Box>
          <Flex
            alignItems={"center"}
            w={"full"}
            display={"inline"}
          >
            <Box
              w={{ base: "full", md: "md", xl: "2xl" }}
              pl={{ xl: "40px" }}
            >
              {/*------------------------------------------------------------------------------------------------------------*/}
              <Flex
                align="center"
                display={'block'}
                pt={{ md: 40 }}
              >

                <Formik
                  initialValues={{
                    name: "",
                    mail: "",
                    message: "",
                    id: 1
                  }}
                  validate={values => {
                    const errors = {};

                    if (!values.name) {
                      errors.name = "Required";
                    } else if (values.name.length < 3) {
                      errors.name = "A valid name is required";
                    }
                    if (!values.mail) {
                      errors.mail = "Required";
                    } else if (
                      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.mail)
                    ) {
                      errors.mail = "Invalid email address";
                    }

                    if (!values.message) {
                      errors.message = "Required";
                    } else if (values.message.length < 10) {
                      errors.message = "Use more text";
                    }
                    return errors;
                  }}
                  onSubmit={(values) => {
                    const requestOptions = {
                      method: 'POST',
                      crossDomain: true,
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(values),
                    };
                    fetch('https://social.appox.ai/api/v01/index.php', requestOptions)
                      .then(response => response.json())
                      .then(data => {
                        //                        console.log({ data });
                        (() =>
                          toast({
                            title: SeccessNotificacion,
                            position: 'bottom',
                            isClosable: true,
                          }))();
                      });
                  }}
                >
                  {({ handleSubmit, errors, touched }) => (
                    <form onSubmit={handleSubmit}>

                      <VStack
                        spacing={4}
                        align="flex-start"
                        border='1px'
                        borderColor="#4AEADE"
                        borderRadius={20}
                        p={5}
                      >

                        <FormControl>
                          <FormLabel htmlFor="name" >
                            <Center>
                              <Text
                                color={'teal.300'}
                                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
                                as={'b'}>
                                <Lang text="Name" />
                              </Text>
                            </Center>
                          </FormLabel>
                          <Field
                            as={Input}
                            id="name"
                            name="name"
                            type="text"
                            variant='flushed'
                          />
                          <Text color={'red'} fontSize={'xs'}>{errors.name && touched.name && errors.name}</Text>
                        </FormControl>

                        <FormControl >
                          <FormLabel htmlFor="mail">
                            <Center>
                              <Text
                                color={'teal.300'}
                                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
                                as={'b'}>
                                <Lang text="Mail" />
                              </Text>
                            </Center>
                          </FormLabel>
                          <Field
                            as={Input}
                            id="mail"
                            name="mail"
                            type="email"
                            variant='flushed'
                          />
                          <Text color={'red'} fontSize={'xs'}>{errors.mail && touched.mail && errors.mail}</Text>
                        </FormControl>

                        <FormControl >
                          <FormLabel htmlFor="message">
                            <Center>
                              <Text
                                color={'teal.300'}
                                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
                                as={'b'}>
                                <Lang text="Info about your dream" />
                              </Text>
                            </Center>
                          </FormLabel>
                          <Field
                            as={Textarea}
                            id="message"
                            name="message"
                            type="text"
                            variant='flushed'
                            color={'gray.100'}
                            bg={"rgba(0,0,0,0)"}
                            _focus={{
                              color: 'gray.100'
                            }}
                            _hover={{
                              color: 'gray.100',
                              bg: "rgba(0,0,0,0)"
                            }}
                          />
                          <Text color={'red'} fontSize={'xs'}>{errors.message && touched.message && errors.message}</Text>
                        </FormControl>

                      </VStack>
                      <Center>
                        <Button
                          type="submit"
                          color={'gray.900'}
                          bgGradient='radial(#4AEADE, teal.300)'
                          mt={"40px"}
                          mb={{ base: 10, md: 10 }}
                          w="95%"
                          h={"60px"}
                          fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
                        >
                          <Lang text="Send" />
                        </Button>
                      </Center>
                    </form>
                  )}
                </Formik>
              </Flex>
              {/**--------------------------------------------------------------------------------- */}

            </Box>

            <Box
              w={{ base: "full", md: "md", xl: "2xl" }}
              pl={{ xl: "40px" }}
            >
              <Text
                as={"h2"}
                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
                fontWeight={"bold"}
              >
                <Lang text="Disclaimer" />
              </Text>
              <Text
                fontSize={{ base: "lg", md: "xl" }}
                pb={{ base: 20, md: 40 }}
              >
                <Lang text="Filling out this form and sending the information through this page does not imply any commitment between AppOX and the Candidate." />
              </Text>
            </Box>
          </Flex>
        </Box>


      </SimpleGrid>

    </Box>
  );
}
